import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=feb1c14c&scoped=true"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=feb1c14c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb1c14c",
  null
  
)

export default component.exports